import React, { useEffect} from 'react';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';

const Snackbar = ({properties}) => {
    
    useEffect(() => {
        if (properties.open) {
            if(![null, undefined].includes(properties.success)){
                enqueueSnackbar(properties.message, {variant: properties.success ? 'success' : 'error'});   
            }
            else{
                enqueueSnackbar(properties.message, {variant: 'warning'});
            }
        }
    }, [properties]);
    
    return ( 
        <SnackbarProvider
            style={{backgroundColor: properties.success ? 'green' : 'red'}}
            anchorOrigin={{ vertical: properties.warning?'bottom':'top', horizontal: properties.warning?'left':'center' }}
            autoHideDuration={properties.warning?300000: 6000}
            />
     );
}

export default Snackbar;